import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import LabOffering from "@/pages/LabOffering";

export const Route = createFileRoute("/es/servicios/lab-services/liberación-de-lotes-qp")({
  head: () => buildRouteHead("/es/servicios/lab-services/liberación-de-lotes-qp"),
  component: LabOffering,
});

